import { styled } from "@mui/material/styles";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Accordiondown from "../images/Accordindown.svg";
export const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `5px solid white`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

export const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<img src={Accordiondown} alt="/" className="accordion-arrow"/>}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "var(--level-7)",
  borderRadius: "6px",
  margin: "0px",
  minHeight: "30px",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper": {
    marginRight: 10,
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(-90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
    color: "white",
    margin: "0",
  },
  "& .MuiTypography-root": {
    color: "white !important",
  },
}));
export const AccordionSummaryInLessonPlanner = styled(
  (props: AccordionSummaryProps) => (
    <MuiAccordionSummary
      expandIcon={<img src={Accordiondown} alt="/" />}
      {...props}
    />
  )
)(({ theme }) => ({
  backgroundColor: "var(--level-1)",
  borderRadius: "6px",
  margin: "0px",
  minHeight: "30px",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper": {
    marginRight: 10,
  },
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(-90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
    color: "var(--level-5)",
    margin: "0",
  },
  "& .MuiTypography-root": {
    color: "var(--level-5)",
    width: "100%",
  },
  "& .MuiSvgIcon-root": {
    color: "#4b5563",
  },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

//Selectmenu Height
const ITEM_HEIGHT = 100;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
export const ThemeMenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 300,
      borderRadius: "10px",
    },
  },
};